// helper to give each field a fresh id
const genField = (overrides) => ({
  id: Math.random() * 10,
  ...overrides,
});

const baseFields = [
  genField({
    name: "Field_Name",
    label: "Field Name",
    type: "Text Box(Single Line)",
    min: 2,
    isRequired: true,
    disabled: true,
  }),
  genField({
    name: "Table_Column_Name",
    label: "Table Column Name",
    type: "Text Box(Single Line)",
    min: 1,
    isRequired: true,
  }),
];

const getColumnFields = (type) => {
  const fields = [...baseFields];
  // if it's a number column, tack on the total checkbox
  if (type === "number" || type === "Number" ||  type === "Boolean" || type === "Bigint"  || type === "BigInt") {
    fields.push(
      genField({
        name: "Column_Total",
        label: "Column Total",
        type: "Check-Box",
      })
    );
  }

  return [
    {
      name: "Table_Column_Details",
      fields,
    },
  ];
};

export {   getColumnFields};
